import React, { useEffect } from 'react';
import { Col, Row } from 'antd';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import { PostTable } from '@app/components/apps/Post/PostTable';
import { BaseBreadcrumb } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import { useNavigate } from 'react-router-dom';
import { BaseButton } from '@app/components/common/BaseButton/BaseButton';

const AllPosts: React.FC = () => {
  const { setBreadcrumb, addHeaderButton, clearHeaderButtons } = useHeader();
  const navigate = useNavigate();

  function handleCreateClick(): void {
    navigate('/add-post');
  }

  useEffect(() => {
    setBreadcrumb(
      <BaseBreadcrumb routes={[{ path: '/posts', breadcrumbName: 'Posts' }]} style={{ marginBottom: '15px' }} />,
    );

    addHeaderButton(
      'Add Post',
      <BaseButton type="primary" size="small" onClick={handleCreateClick}>
        Create
      </BaseButton>,
    );

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, []);

  return (
    <>
      <PageTitle>Posts</PageTitle>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <PostTable />
        </Col>
      </Row>
    </>
  );
};

export default AllPosts;
